import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCaR2j0J71GcQWdcNsCPLeRXZer-vX3-4s",
  authDomain: "taleb-8027f.firebaseapp.com",
  projectId: "taleb-8027f",
  storageBucket: "taleb-8027f.appspot.com",
  messagingSenderId: "657099789161",
  appId: "1:657099789161:web:66f3ed8e1bcf0a986be3f8",
  measurementId: "G-LYNZV9BXZW",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestPermission = () => {
  Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
      return getToken(messaging, { vapidKey: `Notification_key_pair` })
        .then((currentToken) => {
          if (currentToken) {
          } else {
          }
        })
        .catch((err) => { });
    } else {
    }
  });
};

requestPermission();

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
